// extracted by mini-css-extract-plugin
module.exports = {"message":"FormModal_message__IQ9IN","buttons":"FormModal_buttons__D2WyC","submitButton":"FormModal_submitButton__MTcL1"};